// EditEventPanel/index.js
import { connect } from 'react-redux';
import EditEventPanel from '../../components/EditEventPanel';

import { domainType } from '../../constants';

import {
  openEditEventPanelDispatch,
  handleEventInputChangeDispatch,
  submitEventDispatch,
  fetchRecordsForTheEventDispatch,
  handleDeleteEventRecordClickDispatch,
  submitRecordDispatch,
  enableEditEventRecordDispatch,
  handleEditEventRecordInputChangeDispatch,
  openAddEventRecordDialogDispatch,
  openDocumentListDialogDispatch,
  removeEventRecordAttachmentEdit,
  fetchExistingAttachmentsForTheEventRecordDispatch
} from '../../actions';
import { submitMode } from '../../constants';

function mapStateToProps(state, ownProps) {
  return {
    openPanel: state.event.newEvent.showEditEventPanel,
    event: state.event.newEvent.item,
    branchId: state.branch.branch.item && state.branch.branch.item.id,
    records: state.event.recordsForTheEvent.items,
    record: state.event.newRecord.item,
    isEditRecordEnabled: state.event.editRecord.enable,
    recordBeingEdited: state.event.editRecord.item,
    openAddEventRecordDialog: state.event.newRecord.openAddEventRecordDialog,
    loggedInUser: state.users.user.item,
    allAttachments: state.event.editRecord.item.attachmentFiles
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    openEditEventPanel: (open) => {
      dispatch(openEditEventPanelDispatch(open));
    },
    onHandleInputChange: (value, inputFieldName) => {
      dispatch(handleEventInputChangeDispatch(value, inputFieldName));
    },
    submitEvent: (accident) => {
      const mode = submitMode.UPDATE;
      dispatch(submitEventDispatch(accident, mode));
    },
    fetchRecordsForTheEvent: (eventId) => {
      dispatch(fetchRecordsForTheEventDispatch(eventId));
    },
    onHandleDeleteEventRecordClick: (payload) => {
      dispatch(handleDeleteEventRecordClickDispatch(payload));
    },
    submitRecord: (payload, mode, branchId) => {
      dispatch(submitRecordDispatch(payload, mode, branchId));
    },
    enableEditEventRecord: (enableEditRecordMode, recordId, loggedInUserId) => {
      dispatch(enableEditEventRecordDispatch(enableEditRecordMode, recordId));
      dispatch(
        fetchExistingAttachmentsForTheEventRecordDispatch(
          domainType.EVENT_RECORD,
          recordId,
          loggedInUserId
        )
      );
    },
    onHandleEditEventRecordInputChange: (value, inputFieldName) => {
      dispatch(handleEditEventRecordInputChangeDispatch(value, inputFieldName));
    },
    onOpenAddEventRecordDialog: (open) => {
      dispatch(openAddEventRecordDialogDispatch(open));
    },
    openDocumentListDialog: (open) => {
      dispatch(openDocumentListDialogDispatch(open));
    },
    onRemoveAttachment: (attachment) => {
      dispatch(removeEventRecordAttachmentEdit(attachment));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EditEventPanel);
